import { useState } from "react";

import {
  Shield,
  Users,
  FileText,
  LogOut
} from "lucide-react";

import ClientsManager from "./ClientsManager";
import LandingCMS from "./LandingCMS";

import "../styles/dashboard.css";

export default function Dashboard({ onLogout }) {

  const [tab, setTab] = useState("clients");

  return (

    <div className="dashboard">

      {/* HEADER */}
      <div className="dashboard__header">

        <div className="dashboard__title">

          <Shield size={34} />

          <div>
            <h1>
              Admin <span>Panel</span>
            </h1>

            <p>
              Control Center
            </p>
          </div>

        </div>

        <button
          className="dashboard__logout"
          onClick={onLogout}
        >
          <LogOut size={18} />
          Cerrar sesión
        </button>

      </div>

      {/* NAV */}
      <div className="dashboard__nav">

        <button
          className={`dashboard__tab ${
            tab === "clients"
              ? "active"
              : ""
          }`}
          onClick={() =>
            setTab("clients")
          }
        >
          <Users size={18} />
          Clientes
        </button>

        <button
          className={`dashboard__tab ${
            tab === "content"
              ? "active"
              : ""
          }`}
          onClick={() =>
            setTab("content")
          }
        >
          <FileText size={18} />
          CMS Landing
        </button>

      </div>

      {/* MAIN */}
      <div className="dashboard__content">

        <div className="dashboard__hero">

          <h2>
            Bienvenido al Panel
          </h2>

          <p>
            Gestiona clientes,
            contenido e imágenes
            de tu landing premium.
          </p>

        </div>

        {/* STATS */}
        <div className="dashboard__stats">

          <div className="dashboard__stat">

            <h3>
              Clientes
            </h3>

            <span>
              0
            </span>

          </div>

          <div className="dashboard__stat">

            <h3>
              Secciones CMS
            </h3>

            <span>
              4
            </span>

          </div>

        </div>

        {/* CONTENT */}
        <div className="dashboard__panel">

          {tab === "clients" &&
            <ClientsManager />
          }

          {tab === "content" &&
            <LandingCMS />
          }

        </div>

      </div>

    </div>
  );
}